import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchAutoComplete } from "../../../redux/actions/nbhd/search";
import { AutoCompleteItem, AutoCompleteResponse } from "../../../redux/reducers/getNBHDReducer/getAutoCompleteReducer";
import { RootState } from "../../../redux/reducers/root";
import { arrayEquals } from "../../../utils/arrayEquals";
import AmpInput from "../AmpInput/AmpInput";

export interface AmpAddressSearchProps {
    type: string;
    city: string;
    id: string;
    name: string;
    className: string;
    placeholder?: string;
    onAutoCompleteSelect: (item: AutoCompleteItem) => void;
}

export default function AmpAddressSearch(props: AmpAddressSearchProps) {

    const autocomplete = useSelector((state: RootState) => state.NBHDReducer.AutoComplete as AutoCompleteResponse);
    const [autoCompleteResults, setAutoCompleteResults] = useState<Array<AutoCompleteItem>>([]);
    const dispatch = useDispatch();

    const autoCompleteFunction = (e: React.ChangeEvent<Element>) => {
        dispatch(searchAutoComplete(e.target.value, props.type, props.city));
    };

    useEffect(() => {
        if (!autocomplete.loading && autocomplete.results) {
            if (!arrayEquals(autoCompleteResults, autocomplete.results)) {
                setAutoCompleteResults(autocomplete.results);
            }
        }
    }, [autocomplete, autoCompleteResults])

    return (
        <AmpInput
        id={props.id}
        name={props.name}
        className={props.className}
        placeholder={props.placeholder}
        type="text"
        onChange={(e) => { autoCompleteFunction(e) }}
        loading={autocomplete.loading}
        autoComplete="off"
        autoCompleteAPIEnabled={true}
        autoCompleteAPIItems={autoCompleteResults}
        onAutoCompleteSelect={(item) => props.onAutoCompleteSelect(item)}
        realtiveAutoCompleteResultsPosition={true}
        />
    )
}